/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable react/prop-types */
import React from 'react';
import { useLocation } from '@reach/router';
import HeroWithCards from '../../organisms/new-hero-with-cards';
import FreeToolCarousel from '../../organisms/new-current-trending-courses';
import { ClientLogos } from '../../../atoms/client-logos';
import PageSection from '../../organisms/page-section';
import ChecklistWithImage from '../../organisms/checklist-with-image';
import { TrustpilotBusinessReviewHorizontal } from '../../../atoms/trustpilot-business-review';
import { BusinessReviewHorizontal } from '../../../atoms/business-reviews';
import GluTwoColumnText from '../../organisms/glu-two-column-text';
import GLUExitPopUp from '../../../molecules/glu-exit-pop-up';

const NewGluProspectPage = ({ data, setModalOpen, rating }) => {
	const {
		datoCmsGluProspect,
		datoCmsNewGluProspect,
		datoCmsGluTwoColumnText,
	} = data;
	const { title, columnOne, columnTwo } = datoCmsGluTwoColumnText;
	const { hero: heroContent, trendingCourse } = datoCmsNewGluProspect;
	const { locale, checklistImage, checklist } = datoCmsGluProspect;

	const location = useLocation();
	return (
		<>
			<HeroWithCards
				locale={locale}
				hero={heroContent}
				rating={rating}
				privateVideoHash="9ace720501"
				onClick={() => {
					setModalOpen(true);
				}}
			/>
			<GLUExitPopUp locale={locale} />
			<ClientLogos pathname={location.pathname} locale={locale} />
			<FreeToolCarousel trendingCourse={trendingCourse} locale={locale} />
			<div className="glusms:-mt-52 glumd:mt-0 gluxxs:mt-52 gluxs:mt-0 mt-0">
				<PageSection theme="Dark">
					<ChecklistWithImage
						locale={locale}
						listImage={checklistImage}
						content={checklist}
						onClick={() => {
							setModalOpen(true);
						}}
					/>
				</PageSection>
			</div>
			<GluTwoColumnText
				title={title}
				columnOne={columnOne}
				columnTwo={columnTwo}
			/>
			<br />
			<div>
				{locale !== 'en-CA' ? (
					heroContent.trustpilotReview && (
						<div className="flex items-center  justify-center my-2 ">
							<TrustpilotBusinessReviewHorizontal
								className="mb-2"
								rating={rating}
							/>
						</div>
					)
				) : (
					<BusinessReviewHorizontal
						className="flex items-center my-5 -ml-3 "
						// eslint-disable-next-line no-undef
						googleReview={googleReview}
						onlyGR
					/>
				)}
			</div>
		</>
	);
};

export default NewGluProspectPage;
